import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    NgZone,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActionButtonComponent } from "@components/action-button/action-button.component";
import { ButtonComponent } from "@components/button/button.component";
import { DatepickerComponent } from "@components/datepicker/datepicker.component";
import { HeaderComponent } from "@components/header/header.component";
import { SliderComponent } from "@components/slider/slider.component";
import moment from "moment";
import { firstValueFrom } from "rxjs";
import { DateUtils as dateUtils } from "~app/common/utils/date-utils";
import { MinaMaskinlagDialogService } from "../../mina-maskinlag/mina-maskinlag-dialog.service";
import { IArbetsorderDetail } from "../../model/IArbetsorderDetail";
import { ArbetsorderPlaneringSchedulerSettingsTexts } from "./arbetsorder-planering-scheduler-settings.texts";

@Component({
    selector: "rask-arbetsorder-planering-scheduler-settings",
    styleUrls: ["./arbetsorder-planering-scheduler-settings.component.scss"],
    templateUrl: "./arbetsorder-planering-scheduler-settings.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        ActionButtonComponent,
        SliderComponent,
        FormsModule,
        DatepickerComponent,
        ButtonComponent
    ]
})
export class ArbetsorderPlaneringSchedulerSettingsComponent implements OnInit, OnDestroy, OnChanges {
    @Input() currentArbetsorder?: IArbetsorderDetail;
    @Output() maskinlagChanged = new EventEmitter();
    @Input() maxZoom: number;
    @Input() minZoom: number;
    @Output() scrollToArbetsorder = new EventEmitter();
    @Input() startDate: string;
    @Output() startDateChange = new EventEmitter();
    texts = ArbetsorderPlaneringSchedulerSettingsTexts.texts;
    viewDate: string;
    visible = false;
    @Input() zoom: number;
    @Output() zoomChange = new EventEmitter();

    private readonly cdRef = inject(ChangeDetectorRef);
    private readonly elementRef = inject(ElementRef);
    private readonly minaMaskinlagDialogService = inject(MinaMaskinlagDialogService);
    private readonly zone = inject(NgZone);

    clickout = (event) => {
        if (this.visible && !this.elementRef.nativeElement.contains(event.target)) {
            this.visible = false;
            this.cdRef.detectChanges();
        }
    };

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.startDate) {
            this.viewDate = dateUtils.shortDateString(this.startDate);
        }
    }

    ngOnDestroy(): void {
        document.removeEventListener("click", this.clickout);
    }

    ngOnInit(): void {
        this.zone.runOutsideAngular(() => {
            document.addEventListener("click", this.clickout);
        });
    }

    openMinaMaskinlag(): void {
        firstValueFrom(this.minaMaskinlagDialogService.minaMaskinlagModal())
            .then(r => this.maskinlagChanged.emit())
            .catch(e => this.maskinlagChanged.emit());
    }

    setNextMonth(): void {
        this.viewDate = dateUtils.shortDateString(moment(this.viewDate).add(1, "month"));
        this.viewDateChanged(this.viewDate);
    }

    setToday(): void {
        this.viewDate = dateUtils.shortDateString(dateUtils.now());
        this.viewDateChanged(this.viewDate);
    }

    toggleContentPanel(): void {
        this.visible = !this.visible;
    }

    viewDateChanged(dateString: string): void {
        if (moment(dateString).isValid()) {
            this.startDateChange.emit(dateUtils.shortDateString(dateString));
        }
    }

    zoomChanged($event): void {
        if (!isNaN($event)) {
            this.zoomChange.emit($event);
        }
    }

    protected moveToArbetsorder() {
        this.scrollToArbetsorder.emit();
    }
}
